import React, { useState, useEffect } from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import {
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Input,
} from "reactstrap";

function TableView({ columns, data, customPageSize, enabledemployeelist }) {
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [searchText, setSearchText] = useState("");

  // 🔍 filter rows based on searchText
// 🔍 filter rows based on searchText
const filteredData = React.useMemo(() => {
  if (!searchText) return data;
  const lower = searchText.toLowerCase();

  return data.filter((row) =>
    Object.entries(row).some(([key, value]) => {
      // ✅ If it's a React element, try to extract text
      if (typeof value === "string" || typeof value === "number") {
        return value.toString().toLowerCase().includes(lower);
      }
      if (value && value.props && value.props.children) {
        // Handle JSX with text children
        const text = Array.isArray(value.props.children)
          ? value.props.children.join(" ")
          : value.props.children;
        return text.toString().toLowerCase().includes(lower);
      }
      return false;
    })
  );
}, [data, searchText]);


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: filteredData, // 👈 use filtered data
      initialState: {
        pageIndex: currentPageIndex,
        pageSize: customPageSize || 5,
        sortBy: [{ id: "Name", asc: true }],
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    if (customPageSize) {
      setPageSize(customPageSize);
    }
    setCurrentPageIndex(pageIndex);
  }, [setPageSize, pageIndex, customPageSize]);

  return (
    <>
      {/* Search box */}
      

      {/* Page size dropdown */}
      <Row className="mb-2" id="showPageCountInTable">
        <Col sm={2}>
          <select
            className="form-control"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              gotoPage(0);
            }}
          >
            {[5, 10, 20, 30, 40, 50].map((ps) => (
              <option key={ps} value={ps}>
                Show {ps}
              </option>
            ))}
          </select>
        </Col>
      </Row>

      {/* Table */}
      <div className="main-div">
        <div style={{ overflowX: "auto", width: "100%" }}>
        <Table hover {...getTableProps()} >
          <thead>
            {headerGroups.map((headerGroup, p) => (
              <tr key={p} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
           <th
  key={column.id}
  {...(column.render("Header") === "Action"
    ? {}
    : column.getHeaderProps(column.getSortByToggleProps()))}
  style={{
    textAlign: "left",
    whiteSpace:
      ["Reviewer1", "Reviewer2", "Name"].includes(column.render("Header"))
        ? "normal"
        : "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width:
      column.render("Header") === "Select"
        ? "5%"
        : column.render("Header") === "Code"
        ? "6%"
        : column.render("Header") === "Name"
        ? "18%"
        : column.render("Header") === "EligibilityStatus"
        ? "12%"
        : column.render("Header") === "JoiningDate"
        ? "10%"
        : column.render("Header") === "LastReview"
        ? "10%"
        : column.render("Header") === "Status"
        ? "12%"
        : column.render("Header") === "Reviewer1"
        ? "20%"
        : column.render("Header") === "Reviewer2"
        ? "20%"
        : column.render("Header") === "Action"
        ? "6%"
        : "auto",
  }}
>
  <span title={column.render("Header")}>
    {column.render("Header")}
    <small>
      {["Action", "Reviewer1", "Reviewer2", "Select", "Id"].includes(
        column.render("Header")
      ) ? (
        <i></i>
      ) : (
        <i className="fas fa-exchange-alt fa-rotate-90 ml-3"></i>
      )}
    </small>
  </span>
</th>



                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              const isDisabled =
                Array.isArray(enabledemployeelist) &&
                enabledemployeelist.some(
                  (item) => item.employeeId === row.original.Id
                );
              return (
                <tr
                  key={i}
                  {...row.getRowProps()}
                  style={{
                    backgroundColor: isDisabled ? "#f0f0f0" : "white",
                    opacity: isDisabled ? 0.5 : 1,
                  }}
                >
                  {row.cells.map((cell, k) => (
                    <td key={k} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </Table>
        </div>
      </div>

      {/* Pagination */}
      <Row className="table-pagination">
        <Col>
          <Pagination className="pagination">
            <PaginationItem>
              <PaginationLink
                first
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                previous
                onClick={previousPage}
                disabled={!canPreviousPage}
              />
            </PaginationItem>
            &nbsp;
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
            &nbsp;
            <PaginationItem>
              <PaginationLink
                next
                onClick={nextPage}
                disabled={!canNextPage}
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                last
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              />
            </PaginationItem>
          </Pagination>
        </Col>
        <Col>
          <Row className="table-goto-page">
            <Col sm={12} xs={6} md={7} lg={12}>
              <div
                className="input-group mb-3 float-right"
                style={{ width: "180px" }}
              >
                <div className="input-group-prepend">
                  <label className="input-group-text">Go to page</label>
                </div>
                <input
                  className="form-control"
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(page);
                  }}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

const TableWithSortPagtnAppraisal = React.memo((props) => {
  const columns = React.useMemo(
    () => props.thead
      .filter((el) => el !== "Id")
      .map((el) => ({ Header: el, accessor: el })),
    [props.thead]
  );
  const data = React.useMemo(() => props.trow, [props.trow]);

  return (
    <TableView
      columns={columns}
      data={data}
      enabledemployeelist={props.enabledemployeelist}
      customPageSize={props.pageSize}
    />
  );
});

export default TableWithSortPagtnAppraisal;
